import React from "react";
import { Link } from "gatsby";

export default function SupportButtons() {
  return (
    <>
      <div
        className="width-container text-center"
        style={{
          marginTop: 40,
        }}
      >
        <Link
          to={"/donate/"}
          className={"btn primary-btn"}
          style={{ width: "100%" }}
        >
          DONATE NOW
        </Link>
      </div>
      <div className="padding-top-2 text-center">
        <div className="width-container text-center">
          <div className="grid-container btn-group add-width">
            <div className="grid-item grid-item-2">
              <Link to={"/planned-giving/"} className={"btn primary-btn btn-1"}>
                LEGACY GIVING
              </Link>
            </div>
            <div className="grid-item grid-item-2">
              <Link
                to={"/scholarship-endowment/"}
                className={"btn primary-btn btn-2"}
              >
                SCHOLARSHIP ENDOWMENT
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
